import { useEffect } from "react";

const DEFAULT_TITLE = "Club Cycliste Le Boulou | Cyclisme compétition & formation — Pyrénées-Orientales";
const DEFAULT_DESC =
  "Club Cycliste Le Boulou — club de cyclisme de compétition dans les Pyrénées-Orientales. Équipes féminine et masculine, formation des jeunes, projets Sénégal.";

export default function SEO({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} — Club Cycliste Le Boulou` : DEFAULT_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || DEFAULT_DESC);
  }, [title, description]);
  return null;
}
